import { useMutationState } from "@tanstack/react-query";

import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { isValidId } from "@/utilities/id";

export const useInterventionSectionHideCommentsList = (): boolean => {
  const { observation, sectionDatasets } = useInterventionSectionContext();

  const observationId = observation?.id ?? 0;
  const datasetsIds = sectionDatasets.map(({ id }) => id);

  const observationDeleteSuccess = useMutationState({
    filters: {
      mutationKey: ["observations", "delete", observationId],
      status: "success",
    },
  });

  const datasetsDeleteSuccess = useMutationState({
    filters: {
      mutationKey: ["datasets", "delete"],
      status: "success",
      predicate: (mutation) => {
        const mutationKey = mutation.options.mutationKey ?? [];
        const datasetId = mutationKey[2] as number;
        return datasetsIds.includes(datasetId);
      },
    },
  });

  if (!isValidId(observationId)) return true;

  if (observationDeleteSuccess.length > 0) return true;

  if (datasetsIds.length && datasetsDeleteSuccess.length === datasetsIds.length)
    return true;

  return false;
};
